import { render } from "./GetCategoriesSection.vue?vue&type=template&id=80b2654a&ts=true"
import script from "./GetCategoriesSection.vue?vue&type=script&lang=ts"
export * from "./GetCategoriesSection.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\BuildAgent\\work\\bd59560cf4570ff\\src\\TicketSolutions.Personalisation.Client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__